import { Box, InputBase, Typography } from "@mui/material";

import { ReactComponent as ConvertIcon } from "../../assets/icons/convert-colored.svg";
import Numeral from "numeral";

function AmountUnitInputBox({ sx = [], ...props }) {
  const {
    unitValue = "",
    unitOnChange,
    amountValue = "",
    amountOnChange,
    error,
  } = props;
  return (
    <Box
      sx={[
        {
          p: "12px",
          borderRadius: "8px",
          boxShadow: (theme) => theme.shadows[2],
        },
        error && {
          border: (theme) => `1px solid ${theme.palette.error.main}`,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Box
        sx={{
          position: "relative",
          borderRadius: "5px",
          border: (theme) => `1px solid ${theme.palette.grey[6]}`,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            width: 40,
            height: 40,
            bgcolor: "common.white",
            right: 30,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ConvertIcon width={36} height={36} />
        </Box>
        <Box
          sx={{
            py: 1,
            px: 2,
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <Typography variant="subtitle1" color={"grey.3"}>
            مبلغ <Typography variant="caption">(تومان)</Typography>
          </Typography>
          <InputBase
            autoComplete="off"
            inputProps={{
              inputMode: "numeric",
            }}
            value={
              Numeral(amountValue).format("0,0") === "0"
                ? ""
                : Numeral(amountValue).format("0,0")
            }
            onChange={amountOnChange}
          />
        </Box>
        <Box
          sx={{
            py: 1,
            px: 2,
            width: "100%",
            borderBottom: (theme) => `1px solid ${theme.palette.grey[6]}`,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography variant="subtitle1" color={"grey.3"}>
            تعداد واحد تقریبی
          </Typography>
          <InputBase
            autoComplete="off"
            inputProps={{
              inputMode: "numeric",
            }}
            value={
              Numeral(unitValue).format("0,0") === "0"
                ? ""
                : Numeral(unitValue).format("0,0")
            }
            onChange={unitOnChange}
          />
        </Box>

      </Box>
    </Box>
  );
}

export default AmountUnitInputBox;
